import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Dialog from "@mui/material/Dialog";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { APIContext } from "src/components/Contexts/APIContext"
import Typography from "@mui/material/Typography";
import QaiChallengeFilterViewModel from "./ViewModels/QaiChallengeFilterViewModel";
import getActiveFilterDateRangeFlag from "../../Utilities/DateRange";
import DialogTitle from "@mui/material/DialogTitle";
import { QaiScorecardChallengeQuestionViewModel } from "./ViewModels/QaiScorecardChallengeQuestionsViewModel";

interface ISearchAgentCallAnswerDialogProps {
    dialogOpen: boolean
    setDialogOpen: (value: boolean) => void;
    questionViewModel: QaiScorecardChallengeQuestionViewModel
    filters: QaiChallengeFilterViewModel
}

export default function SearchAgentCallAnswerDialog({ dialogOpen, questionViewModel, setDialogOpen, filters }: ISearchAgentCallAnswerDialogProps) {
    const { get } = useContext(APIContext);
    const [answers, setAnswers] = useState<string[]>([]);
    const [selectedAnswer, setSelectedAnswer] = useState<string | null>(null);

    useEffect(() => {
        get(
            'QaiScorecardChallenge',
            `GetAnswers?questionId=${questionViewModel.questionId}`,
            (data) => setAnswers(data));
    }, [])

    const answerSelectHandler = (e: any) => {
        setSelectedAnswer(e.target.value);
    }

    const handleDialogClose = () => {
        setDialogOpen(false);
        setSelectedAnswer(null);
    }

    let searchAgentCallsLink = 'Search/SearchIndex'
        + `?client=${questionViewModel.client}`
        + `&templateId=${questionViewModel.templateId}`
        + `&sectionId=${questionViewModel.sectionId}`
        + `&questionId=${questionViewModel.questionId}`
        + `&answer=${selectedAnswer}`
        + `&dateRangeFlag=${getActiveFilterDateRangeFlag(filters)}`

    return (
        <Dialog
            open={dialogOpen}
            fullWidth
            sx={{ height: '100%' }}
            maxWidth="md">
            <DialogTitle>
                Find example calls
            </DialogTitle>
            <Grid container size={12} >
                <Grid container height="300px">
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center">
                        <Grid size={8}>
                            <Typography sx={{ marginBottom: 4 }}>This will send you to a callfinder search with preset filters for Q-AI scored calls that contain a question with a matching answer</Typography>
                            <Typography>Question:</Typography>
                            <Typography gutterBottom paddingBottom={2}>{questionViewModel.questionText}</Typography>
                            <InputLabel>Answer</InputLabel>
                            <Select fullWidth label="Answer" value={selectedAnswer} onChange={answerSelectHandler}>
                                {
                                    answers.map(answer => <MenuItem key={answer} value={answer}>{answer}</MenuItem>)
                                }
                            </Select>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        size={12}
                        justifyContent="flex-end"
                        alignItems="flex-end"
                        spacing={1}>
                        <Grid>
                            <Button variant="contained" onClick={handleDialogClose}>Close</Button>
                        </Grid>
                        <Grid>
                            <Button
                                variant="contained"
                                disabled={!selectedAnswer}
                                href={searchAgentCallsLink}>
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    )
}